import React from "react";
import "./SectionHeader.scss";
import { useTranslation } from 'react-i18next';

interface SectionHeaderProps {
  /** The primary text to display in the header. */
  text: string;
  /** A secondary fallback for the text. It is recommended to use `text`. */
  title?: string;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ text, title }) => {
  const { t } = useTranslation();
  // Fallback chain: uses `text`, then `title`, then a default string.
  const displayText = text || title || "Section Header";
  return <h2 className="section-header">{t(displayText)}</h2>;
};

export default SectionHeader;
